export class UrlPartValidationResult {
    constructor() {
        this.invalidReasons = new Array<string>();
    }
    get valid(): boolean {
        return this.invalidReasons.length === 0;
    }
    invalidReasons: Array<string>;
}